import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "styled-components";
import { Container } from "@miro-site/core";
var HeaderContainer = styled(Container).attrs(function(param) {
    var theme = param.theme;
    return {
        as: "div",
        $px: theme.header.container.horizontalPadding,
        $styles: {
            maxWidth: theme.header.container.maxWidth
        }
    };
}).withConfig({
    componentId: "sc-dfcd3c8c-0"
})(_templateObject());
HeaderContainer.displayName = "HeaderContainer";
export default HeaderContainer;
